import React, { useCallback } from 'react'
import cn from 'classnames'
import { DropdownItem } from 'util/ui'
import { SVGIcon } from 'shared/ui'
import presenceTypes from '../presenceTypes'

const PresenceDropdownItem = React.memo(props => {
  const { presence, className, onClick, ...rest } = props
  const {
    name = 'Unknown',
    description = '',
    className: presenceClassName = '',
  } =
    presenceTypes[presence] || {}

  const handleClick = useCallback(
    () => {
      if (onClick) onClick(presence)
    },
    [onClick, presence]
  )

  return (
    <DropdownItem
      className={cn(className, presenceClassName)}
      aria-checked="false"
      onClick={handleClick}
      {...rest}
    >
      <div className="leftcol">
        <div className="indicator">
          {presence !== 'autoPresence' && <div className="dot">&nbsp;</div>}
          {presence === 'autoPresence' && <SVGIcon name="sync" size={12} />}
        </div>
      </div>
      <div className="rightcol">
        <div className="name">{name}</div>
        <div className="description">{description}</div>
      </div>
    </DropdownItem>
  )
})

export default PresenceDropdownItem
